import { render } from "./EditParent.vue?vue&type=template&id=35bb14c5"
import script from "./EditParent.vue?vue&type=script&lang=js"
export * from "./EditParent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/parents/EditParent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35bb14c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35bb14c5', __exports__)) {
    console.log('reload')
    api.reload('35bb14c5', __exports__)
  }
  
  module.hot.accept("./EditParent.vue?vue&type=template&id=35bb14c5", () => {
    console.log('re-render')
    api.rerender('35bb14c5', render)
  })

}


export default __exports__